import { Stack, Typography } from '@mui/material';
import { theme } from 'theme';
import { StyledBoxContent } from './styles';

interface AboutMeSectionProps {
  bio: string;
}

export const AboutMeSection = ({ bio }: AboutMeSectionProps) => {
  return (
    <Stack spacing={1}>
      <Typography variant="Web_Title_22">Biography</Typography>
      <StyledBoxContent>
        <Typography
          variant="Web_paragraph"
          color={theme.palette.text.secondary}
        >
          {bio}
        </Typography>
      </StyledBoxContent>
    </Stack>
  );
};
